export const StorageKeys = {
  AccessToken: '@cp-kkshop/access_token',
  UserInfo: '@cp-kkshop/user_info',
};
